// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5cb146cf","893":"cf4396f9"}[chunkId] + ".chunk.js";
};